module.exports = __webpack_public_path__ + "static/media/cisco_ccna.a2bce878.jpg";